import { Component, effect, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import type { LanguageCode } from '../model/language-code';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { ProgressBarComponent } from '@pct-ng/common/component';

@Component({
  selector: 'cappus-translate-able-form-fragment-wrapper',
  templateUrl: './translate-able-form-fragment-wrapper.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonToggle,
    MatButtonToggleGroup,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    ReactiveFormsModule,
    MatCardContent,
    ProgressBarComponent,
  ],
})
export class TranslateAbleFormFragmentWrapperComponent {
  protected readonly selectedLanguageControl = new FormControl<LanguageCode>('hu', {
    nonNullable: true,
  });
  readonly loading = input(false);
  readonly hasError = input<Record<LanguageCode, boolean> | undefined>({} as any);
  readonly selectedLanguage = input.required<LanguageCode>();
  readonly changeLanguage = outputFromObservable(this.selectedLanguageControl.valueChanges);

  constructor() {
    effect(() => {
      const selectedLanguage = this.selectedLanguage();
      this.selectedLanguageControl.setValue(selectedLanguage, { emitEvent: false });
    });

    effect(() => {
      if (this.loading()) {
        this.selectedLanguageControl.disable();
      } else {
        this.selectedLanguageControl.enable();
      }
    });
  }
}
